import { css } from 'styled-components';
import { rem } from 'polished';

const listStyles = () => css`
    margin-bottom: ${rem(16)};
    padding-left: ${rem(16)};
`;

export default listStyles;
